.table {
  width: 230px;
}
